import "nprogress/nprogress.css";
import NProgress from "nprogress";
import { useEffect } from "react";
import { useIsFetching } from "@tanstack/react-query";
import { useLocation } from "react-router-dom";

NProgress.configure({
  showSpinner: false,
  speed: 400,
  minimum: 0.08,
  trickleSpeed: 200,
});

export function NProgressBar() {
  const blockingFetchCount = useIsFetching({
    predicate: (query) => {
      const isFetching = query.state.fetchStatus === "fetching";
      if (!isFetching) return false;

      const hasResolvedData = typeof query.state.data !== "undefined";
      return !hasResolvedData;
    },
  });
  const location = useLocation();

  // Show progress bar on route navigation
  useEffect(() => {
    NProgress.start();
    NProgress.done();
  }, [location.pathname, location.search]);

  // Show progress bar on data fetching
  useEffect(() => {
    if (blockingFetchCount > 0) {
      NProgress.start();
    } else {
      NProgress.done();
    }
  }, [blockingFetchCount]);

  return null;
}

export default NProgressBar;
